import {Box, Grid, TextField, useTheme} from "@mui/material";
import { styles } from "../../login/LoginStyles";
import LayoutContentTitle from "../../../components/layout/LayoutContentTitle";
import FormSection from "../../../forms/FormSection";
import { observer } from "mobx-react";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import * as React from "react";
import ArticlesOfFreeOrderConfirmationRequestTableComponent from "./ArticlesOfFreeOrderConfirmationRequestTableComponent";
import Typography from "@mui/material/Typography";
import ArticlesOfFreeOrderConfirmationRequestComponent from "./ArticlesOfFreeOrderConfirmationRequestComponent";

function FreeOrderConfirmationRequestComponent({order}) {
    const theme = useTheme();
    const style = styles(theme);
    return (
        <LayoutContentWrapper
            renderContent={() => (
                <div>
                    <Box mb={2}>
                        <div style={style.titleContainer}>
                            <LayoutContentTitle title={`Pedido ${order.number}`} />
                        </div>
                    </Box>

                    <FormSection>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography sx={style.formSectionTitle}>
                                    Cliente
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Razón social"
                                    value={order.customer.businessName}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Número de cliente"
                                    value={order.customer.customerCode}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Nombre de fantasía"
                                    value={order.customer.fantasyName}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography sx={style.formSectionTitle}>
                                    Punto de entrega
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Punto de entrega"
                                    value={order.deliverySite.deliverySiteName}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Dirección"
                                    value={order.deliverySite.deliverySiteAddress}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Localidad"
                                    value={order.deliverySite.deliverySiteCity}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography sx={style.formSectionTitle}>
                                    Orden de compra
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Número de orden"
                                    value={order.purchaseOrderNumber}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={style.formSectionTitle}>
                                    Fecha de entrega
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Fecha de entrega"
                                    value={order.deliveryDate}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={style.formSectionTitle}>
                                    Comentario
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Comentario"
                                    value={order.observations}
                                    fullWidth
                                    multiline
                                    minRows={4}
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography sx={style.formSectionTitle}>
                                    Artículos
                                </Typography>
                            </Grid>
                            <ArticlesOfFreeOrderConfirmationRequestComponent title="" children={ArticlesOfFreeOrderConfirmationRequestTableComponent}>
                                <ArticlesOfFreeOrderConfirmationRequestTableComponent label="" articles={order.articles} />
                            </ArticlesOfFreeOrderConfirmationRequestComponent>
                        </Grid>
                    </FormSection>
                </div>
            )}
        />
    );
}

export default observer(FreeOrderConfirmationRequestComponent);